// src/services/HomePage/ShopByCategoryApi.js
export const fetchCategories = async () => {
  try {
    // ✅ Base URL from .env file
    const endpoint = `${process.env.REACT_APP_API_URL}MasterAPI/GetCategories`;

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch categories");

    const data = await response.json();

    // ✅ Sirf active categories return kare
    return data.filter((item) => item.isActive === true);
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};
